import IndividualPrintsBuilder from './IndividualPrintsBuilder';

export default IndividualPrintsBuilder;
